import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from './ArcButton';

interface ContactSupportButtonProps {
  path: string;
}

export const ContactSupportButton = ({ path }: ContactSupportButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ArcButton
      arcColor="#FF5B44"
      w="80%"
      my={6}
      onClick={() => navigate(path)}
      data-testid={'contact-support-button'}
      textOverflow="auto"
    >
      {t('Common.contact support')}
    </ArcButton>
  );
};
